import styled from 'styled-components';
import colors from '@theme/colors';

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

export const Td = styled.td.attrs({
  colSpan: ({ colSpan }) => colSpan || 1,
})`
  color: ${({ primary, danger }) =>
    (danger && colors.DANGER) || (primary && colors.PRIMARY) || colors.DARK_GREY};
  padding: ${({ padding }) => padding || '15px 35px'};
  font-size: 14px;
  width: ${({ width }) => width || 'auto'};
`;

const borderWidth = ({ expanded }) => (expanded ? '1px' : '1px');
const borderColor = ({ expanded }) => (expanded ? '#d8d8d8' : '#d8d8d8');

export const Row = styled.tr`
  padding: 5px 0;
  background-color: ${({ background }) => (background ? colors.WHITE : 'transparent')};
  border-bottom: ${borderWidth} solid ${borderColor};
`;



// WEBPACK FOOTER //
// ./components/layout/ParticipantsTable.js